import type { ProductVariantExtended } from '~/types/product/ProductVariantExtended';

export const isSecondHandProduct = (product: ProductVariantExtended): boolean => {
  return product?.sku?.slice(0, 3) === 'EX2';
};
